import React from 'react';

const NewsModal = ({ newsItem, onClose, isOpen }) => {
    if (!isOpen || !newsItem) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-md px-4">
            <div className="bg-white dark:bg-[#1e1e1e] rounded-3xl p-6 sm:p-8 w-full max-w-lg shadow-2xl relative transition-all duration-300 ease-in-out">
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-red-500 text-2xl"
                    aria-label="Close"
                >
                    &times;
                </button>

                {/* Title */}
                <h2 className="text-xl sm:text-2xl font-bold text-center text-gray-800 dark:text-white mb-4">
                    {newsItem.title}
                </h2>

                {/* Content */}
                {Array.isArray(newsItem.description) ? (
                    <ul className="space-y-3 max-h-[60vh] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600 pr-1">
                        {newsItem.description.map((book, idx) => (
                            <li key={idx} className="flex items-start gap-3">
                                {book.image && (
                                    <img
                                        src={book.image}
                                        alt="Book cover"
                                        className="w-14 h-14 object-cover rounded-md shadow"
                                    />
                                )}
                                <span className="text-gray-700 dark:text-gray-200 text-base">{book.title}</span>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-gray-700 dark:text-gray-300 whitespace-pre-line text-base">
                        {newsItem.description}
                    </p>
                )}
            </div>
        </div>
    );
};

export default NewsModal;